"use client";
import {
  avatar_group_default
} from "./chunk-NB7VH5TP.mjs";
import {
  avatar_default
} from "./chunk-SXMLSBOY.mjs";
import {
  AvatarIcon
} from "./chunk-25E6VDTZ.mjs";
import {
  useAvatarGroup
} from "./chunk-QH65JCLF.mjs";
import {
  useAvatar
} from "./chunk-LTC67JRI.mjs";
import {
  AvatarGroupProvider,
  useAvatarGroupContext
} from "./chunk-JUJ53SJZ.mjs";
export {
  avatar_default as Avatar,
  avatar_group_default as AvatarGroup,
  AvatarGroupProvider,
  AvatarIcon,
  useAvatar,
  useAvatarGroup,
  useAvatarGroupContext
};
